import { useEffect, useRef, useState } from "react";
import SplideSlider from "../../../../../components/Slider/SplideSlider";
import PropertyCard from "../../../../../components/Card/PropertyCard";
import { relatedProperties } from "../../../../../services/customer/project";
import { AWS_BASE_URL, DOMAIN_URL } from "../../../../../clientConfig";
import { formatPrice } from "../../../../../utils";
import {
  saveProperty,
  unSaveProperty,
} from "../../../../../services/customer/property";

const PropertyInProject = ({
  projectId,
  handleDropdownActions,
  handleModalAuthOpen,
}: {
  projectId: string | undefined;
  handleDropdownActions: (item: any) => void;
  handleModalAuthOpen: () => void;
}) => {
  const hasFetchApiRef = useRef(false);
  const [stateRelatedProperties, setStateRelatedProperties] = useState<
    any[] | null
  >(null);
  const [savedProperties, setSavedProperties] = useState<string[]>([]);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);

  const handleApiResponse = (data: any) => {
    setStateRelatedProperties(data);

    const savedData = data
      ?.filter((property: any) => property?.is_saved)
      ?.map((property: any) => property?._id);
    setSavedProperties(savedData);
  };

  useEffect(() => {
    if (projectId && !hasFetchApiRef.current) {
      relatedProperties(projectId, handleApiResponse, () => {});
      hasFetchApiRef.current = false;
    }
  }, [projectId]);

  return (
    <>
      {stateRelatedProperties && stateRelatedProperties?.length ? (
        <div className="p-4 space-y-8">
          <div className="flex-1">
            <h2 className="text-center font-normal text-3xl lg:text-4xl text-dark-cyan">
              <span className="font-black">Properties</span> In This Project
            </h2>
          </div>
          <div className="px-4">
            <div className="project-list">
              <SplideSlider
                showItems={4}
                options={{
                  pagination: false,
                  gap: "20px",
                  breakpoints: {
                    1650: {
                      perPage: 4,
                      perMove: 4,
                    },
                    1200: {
                      perPage: 3,
                      perMove: 3,
                    },
                    1024: {
                      perPage: 2,
                      perMove: 2,
                    },
                    768: {
                      perPage: 1,
                      perMove: 1,
                    },
                  },
                }}
              >
                {stateRelatedProperties?.map((property) => (
                  <PropertyCard
                    key={property?._id}
                    id={property?._id}
                    imageUrl={
                      property?.property_images?.images?.[0]?.image
                        ? `${AWS_BASE_URL}${property?.property_images?.images?.[0]?.image}`
                        : ""
                    }
                    price={
                      property?.price ? `₹ ${formatPrice(property?.price)}` : ""
                    }
                    propertyType={property?.category?.name}
                    title={property?.name}
                    navigateUrl={`${DOMAIN_URL}property-information/${property?.slug}/${property?._id}`}
                    address={property?.location}
                    handleWithOutLogin={handleModalAuthOpen}
                    actionMenu={[
                      {
                        key: "share",
                        value: "Share",
                        id: property?._id,
                      },
                      {
                        key: "report",
                        value: "Report",
                        id: property?._id,
                      },
                    ]}
                    handleDropdownActions={handleDropdownActions}
                    headerAction={{
                      show: true,
                      checked: savedProperties?.includes(property?._id),
                      loading: saveLoading,
                      onClick: () => {
                        setSaveLoading(true);
                        if (savedProperties?.includes(property?._id)) {
                          unSaveProperty(property?._id, setSaveLoading, () => {
                            const filterProperties = savedProperties?.filter(
                              (savedProperty) => property?._id !== savedProperty
                            );
                            setSavedProperties(filterProperties);
                          });
                        } else {
                          saveProperty(property?._id, setSaveLoading, () => {
                            setSavedProperties((prev: any) => [
                              ...prev,
                              property?._id,
                            ]);
                          });
                        }
                      },
                    }}
                    featuresList={[
                      {
                        iconName: "squareFit",
                        value: property?.total_area
                          ? `${property?.total_area} Sq`
                          : "",
                        iconClassName: "w-5 h-5",
                      },
                      {
                        iconName: "bedroom-icon",
                        value: property?.no_of_bedrooms,
                        iconClassName: "w-5 h-5",
                      },
                      {
                        iconName: "bathroom-icon",
                        value: property?.no_of_bathrooms,
                        iconClassName: "w-5 h-5",
                      },
                    ]}
                  />
                ))}
              </SplideSlider>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PropertyInProject;
